import { InputType } from 'reactstrap/es/Input';
import { IAction, ControlTypeEnum, IColumnDef } from "../abstraction/index";
import { InternalTypeEnum } from "./index";

export class ColumnModel {

	Value: string;
	InputInlineStyle: string;
	HasFocus: boolean;
	Min: number;
	Max: number;
	MinLength: number;
	MaxLength: number;
	Required: boolean;
	Step: number;
	InputType: InputType;
	PreviousValue: string;
	IsDirty: boolean;

	Key: string;
	Title: string;
	FieldName: string;
	Visible: boolean;
	Disable: boolean;
	Type: ControlTypeEnum;
	Id: number;
	DataType: InternalTypeEnum;

	OnChange: string;
	PlaceHolder: string = "";
	ErrorMessage: string = "";
	Class: string = "";

	//#region Colonnes fusionn�es 

	ColMergeTargets: string = "";		// Nom des colonnes avec lesquelles ont doit merger 
	ColMergeTitle: string = "";		    // Titre de la colonne issue du merge
	ColMergeCSS: string = "";			// Class CSS
	ColSearchField: string = "";		// Zone de recherche dans le tableau
	ColMergeSeparator: string = "";		// S�parateur

	IsMerged: boolean = false;		// Flag indiquant que la colonne courante est une colonnes fusionn�e cr��e dynamiquement

	//#endregion Colonnes fusionn�es 

	//#region Progress Attributes

	ProgressColor: string;

	//#endregion

	RowEditCond: string = "";

	ColBarCodeName: string = "";
	ColBarCodeValidCond: string = "";
	ColCbUnique: boolean = false;

	Pattern: string = "";

	ShowMoreIcon: string = "";

	public static create(s: IColumnDef): ColumnModel {
		let it = new ColumnModel();
		it.Title = s.Title;
		it.Key = s.Code;
		it.FieldName = s.FieldName;
		it.Type = s.Type;
		it.Id = s.Id;
		it.DataType = s.ColType;
		it.Visible = s.Visible ? true : false;		// Le test permet de convertir un 'undefined' en false
		it.Disable = s.Disable ? true : false;
		it.Class = s.Class;

		it.IsMerged = s.IsMerged ? true : false;
		return it;
	}
}
